var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.container,{tag:"component"},_vm._l((_vm.lines),function(line){return _c(_vm.lineComponent,{key:line,tag:"component",class:_vm.lineComponentClass},[_vm._v(_vm._s(line))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }